<template>
    <!-- <div class="scroll-top" :class="{'not-share':!share}"> -->
    <div>
        <el-backtop :bottom="100" :visibility-height="20" class="scroll-top" :class="{'not-share':!share}">
            <div class="share" v-show="share" >
                <div class="qr-code-box">
                    <h3>请用微信扫一扫</h3>
                    <img src="" alt="">
                    <p class="tc">请扫描上方二维码进行分享</p>
                </div>
            </div>
            <div class="backtop"></div>
        </el-backtop>
    </div>
</template>
<script>
export default {
    props: {
        share: {
            type:Boolean,
            default:false,
        }
    },
    data() {
        return{
            
        }
    }
}
</script>




<style lang="less">
    .scroll-top {
        position: fixed;
        width: 40px;
        height: 92px;
        left: 10%;
        border-radius: 20px;
        background-color: #fff;

        .share {
            position: absolute;
            width: 20px;
            height: 20px;
            top: 18px;
            left: 10px;

            color: #333;
            background-image: url("../../../../static/news/share@2x.png");
            background-repeat: no-repeat;

            cursor: pointer;

            &:hover .qr-code-box{
                display: block;
            }

            
            .qr-code-box {
                display: none;
                position: absolute;
                top: -100px;
                left: 50px;

                border-radius: 10px;
                padding-bottom: 20px;
                width: 200px;

                background-color: #fff;


                h3 {
                    line-height: 40px;

                    font-size: 16px;
                    text-align: center;
                   
                    border-bottom: 1px solid #EDEDED;
                }

                img {
                    display: block;

                    margin: 20px auto;
                    width: 100px;
                    height: 100px;

                    background-color: #EDEDED;
                }
                
                p {
                    font-size: 14px;
                }

                &::before {
                    content: ' ';
                    position: absolute;
                    top: 90px;
                    left: -12px;
                    width: 0;
                    height: 0;
                    border-top: 15px solid transparent;
                    border-bottom: 15px solid transparent;
                    border-right: 15px solid #fff;
                }
                
            }
        }

        .backtop {
            position: absolute;
            bottom: 0;

            border-radius: 50%;
            width: 40px;
            height: 40px;
            
            background-color: #1B4B8F;
            background-image: url("../../../../static/news/backtop@2x.png");
            background-repeat: no-repeat;
            background-position: 10px 11px;
            
            .el-icon-caret-top {
                display: none;
            }
        }
    
    }
    .el-backtop:hover {
        background-color:#fff;
    }

    .el-backtop.not-share {
        background-color: transparent;
        box-shadow:none;
    }



    
</style>